<template>
    <div id="citySelect">
        <el-cascader :options="city"  clearable :show-all-levels="false" v-model="hospAddArr" @active-item-change="handleChange" :props="propAdd"></el-cascader>
    </div>
</template>

<script>
export default {
    name:'citySelect',
    data(){
        return{
            propAdd:{
                value: 'value',
                children: 'cities'
            },
            city:[],//地区数据
            hospAddArr:[],//选择的地址code
            numArr:[]//记录选择的每级地址下标
        }
    },
    props:{
        hospCityArr:Array
    },
    mounted(){
        console.log(this.hospAddArr)
        this.getCity(this.city,'',0);
    },
    methods:{
        //选择地区
        handleChange(value){
            this.hospAddArr=value;
            
            if(this.numArr.length>=value.length){
                this.numArr.splice(value.length-1,this.numArr.length-value.length+1);
            }
            if(value.length==1){
                for(let i=0;i<this.city.length;i++){
                    if(this.city[i].value==value[0]){
                        this.numArr[0]=i;
                        this.getCity(this.city[i].cities,value[value.length-1],value.length)
                        break;
                    }        
                }
            }
            else{
                var cityObj=this.city[this.numArr[0]].cities;
                for(let i=1;i<this.numArr.length;i++){
                    cityObj=cityObj[this.numArr[i]].cities;
                }
                for(let j=0;j<cityObj.length;j++){
                    if(cityObj[j].value==value[value.length-1]){
                        this.numArr[value.length-1]=j;
                        this.getCity(cityObj[j].cities,value[value.length-1],value.length)
                        break;
                    }        
                }
            }
        },
        //获取地区列表(要填充的数组对象，当前对象的地区code值，要请求的地址级数)
        getCity(cityObj,code,length){
            if(cityObj.length>0){
                return;
            }
            this.$ajax.post(this.$domain.listRegion,{
                code:code,
                level:length+1
            })
            .then(ret=>{
                this.$common.getConsole('获取地址——-------------------',ret.data)
                if(ret.data.code==200){
                    var list=ret.data.data;
                    for(var i=0;i<list.length;i++){
                        if(length>=2){
                            cityObj.push({
                                value:list[i].value,
                                label:list[i].label
                            })
                        }
                        else{
                            cityObj.push({
                                value:list[i].value,
                                label:list[i].label,
                                cities:[]
                            })
                        }
                    }
                }
                else if(ret.data.code==401){
                    this.$message.error('登录失效！请重新登陆');
                    this.$router.push({path:'/login'})
                }
                else if(ret.data.code==11){
                    this.$message.error('已是最后一级数据，没有下一级了~');
                }
                else{
                    this.$message.error(ret.data.message)
                }
            })
            .catch(err=>{
                this.$common.getConsole('获取地址——-catch------------------',err)
            })
        },
    },
    watch:{
        hospAddArr(val){
            this.$emit('hospAddArr',val)
        },
        hospCityArr(newValue,oldValue){
            this.hospAddArr=newValue
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/citySelect.vue